/* eslint-disable react-hooks/exhaustive-deps */
import { memo } from 'react';
import { DialogSearchLocationWrapper } from './styled';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsLoading,
  selectListLocation,
  selectListPlaceCategory,
  selectOptionsFilterListLocation,
  selectTrans,
} from '@containers/App/selectors';
import { I_OptionsFilterListLocation } from '@containers/App/types';
import { actions } from '@containers/App/slice';
import { useState, useEffect } from 'react';
import LoadingContainer from '@components/LoadingContainer';
import { useDebounce } from '@utils/hooks/useDebounce';
import useNavigateBetweenProject from '@containers/Home/hook/useNavigateBetweenProject';

interface Props {
  isVisible: boolean;
  onCancel: () => void;
}

const DialogSearchLocation = memo(({ isVisible, onCancel }: Props) => {
  const dispatch = useDispatch();

  const trans = useSelector(selectTrans);
  const isLoading = useSelector(selectIsLoading);
  const listLocation = useSelector(selectListLocation);
  const listPlaceCategory = useSelector(selectListPlaceCategory);
  const optionsFilterListLocation = useSelector(
    selectOptionsFilterListLocation,
  );

  const [searchValue, setSearchValue] = useState('');

  const { onChangeProject } = useNavigateBetweenProject();

  const onChangeOptionsFilterListLocation = (
    options: Partial<I_OptionsFilterListLocation>,
  ) => {
    if (options.categoryIds) setSearchValue('');
    dispatch(actions.onChangeOptionsFilterListLocation(options));
  };
  const searchValueDebounce = useDebounce({ value: searchValue, delay: 500 });

  useEffect(() => {
    if (searchValueDebounce !== optionsFilterListLocation?.nameLocation)
      onChangeOptionsFilterListLocation({ nameLocation: searchValueDebounce });
  }, [searchValueDebounce]);

  const onNavigate = (slug: string) => {
    if (slug) {
      onCancel();
      onChangeProject(slug);
    }
  };

  return (
    <DialogSearchLocationWrapper
      className="modal-filter"
      show={isVisible}
      onHide={onCancel}
      centered
    >
      <div className="cards-header">
        <div className="--icon">
          <img src="/static/img/icon-sort-alt.svg" alt="" />
        </div>
        <h5 className="--title">Bộ lọc</h5>
      </div>
      <div className="cards-body">
        <div className="--filter">
          <div className="--search">
            <input
              type="text"
              placeholder={trans ? trans['fe.tour.input.search'] : ''}
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
            />
            <i className="fa-light fa-magnifying-glass"></i>
          </div>
          <div className="--cate">
            <h6 className="--name">Loại hình</h6>
            <div className="--tab">
              <div
                className={`--item ${
                  optionsFilterListLocation.categoryIds.length ? '' : 'active'
                }`}
                onClick={() =>
                  onChangeOptionsFilterListLocation({
                    categoryIds: [],
                  })
                }
              >
                <span>{trans ? trans['fe.tour.filter.all'] : ''}</span>
              </div>
              {listPlaceCategory.map(item => (
                <div
                  key={item.id}
                  className={`--item ${
                    optionsFilterListLocation.categoryIds.indexOf(item.id) !==
                    -1
                      ? 'active'
                      : ''
                  }`}
                  onClick={() =>
                    onChangeOptionsFilterListLocation({
                      categoryIds: [item.id],
                    })
                  }
                >
                  <img
                    src={
                      item?.icon?.thumbnail_640_jpg ||
                      item?.icon?.thumbnail_720_jpg ||
                      item?.icon?.default
                    }
                    alt=""
                  />
                  <span>
                    {item.name} ({item.numberTour})
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <LoadingContainer loading={isLoading}>
          <div className="--listLocation">
            {listLocation.map(item => (
              <div
                key={item.id}
                className="--item itemLocation link"
                onClick={() => onNavigate(item.projectId?.slug)}
              >
                <div className="--imgLct">
                  <img
                    src={
                      item?.locationImage?.thumbnail_640_jpg ||
                      item?.locationImage?.thumbnail_720_jpg ||
                      item?.locationImage?.default
                    }
                    alt=""
                  />
                </div>
                <div className="--totalImg">
                  <i className="fa-regular fa-image"></i>
                  <span>{item.numberImageTour}</span>
                </div>
                <div className="--titleLct">
                  <h6 className="--nameLct">{item.name}</h6>
                  <div className="--viewLct">
                    <div className="--iconLct">
                      <img src="/static/img/icon-eye.svg" alt="" />
                    </div>
                    <span>{item.countView}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </LoadingContainer>
      </div>
    </DialogSearchLocationWrapper>
  );
});

export default DialogSearchLocation;
